
// import React from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   Divider,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
// } from "@mui/material";
// import { Add, Delete, History } from "@mui/icons-material";

// export const TODAY = new Date().toISOString().split("T")[0];

// export const STATUS_META = {
//   draft: { label: "Draft", color: "default" },
//   submitted: { label: "Submitted", color: "primary" },
//   legal_review: { label: "Legal Review", color: "info" },
//   approved_l1: { label: "Approved (Shirastedar)", color: "success" },
//   rejected_l1: { label: "Rejected (Shirastedar)", color: "error" },
//   approved_l2: { label: "Approved (Tahsildar)", color: "success" },
//   rejected_l2: { label: "Rejected (Tahsildar)", color: "error" },
//   approved_l3: { label: "Approved (CA)", color: "success" },
//   rejected_l3: { label: "Rejected (CA)", color: "error" },
//   approved_ac: { label: "Approved (AC)", color: "success" },
//   rejected_ac: { label: "Rejected (AC)", color: "error" },
//   approved_js: { label: "Approved (JS)", color: "success" },
//   rejected_js: { label: "Rejected (JS)", color: "error" },
//   approved_ca: { label: "Approved (CA/SPLOCA)", color: "success" },
//   rejected_ca: { label: "Rejected (CA/SPLOCA)", color: "error" },
//   issued: { label: "Issued", color: "success" },
//   final: { label: "Finalised", color: "success" },
// };

// export const StatusChip = ({ status }) => {
//   const m = STATUS_META[status] || { label: status, color: "default" };
//   return <Chip label={m.label} color={m.color} size="small" />;
// };

// export const FG = ({ children, cols = 3, sx = {} }) => (
//   <Box
//     sx={{
//       display: "grid",
//       gridTemplateColumns: `repeat(${cols}, 1fr)`,
//       gap: 2,
//       mb: 2,
//       ...sx,
//     }}
//   >
//     {children}
//   </Box>
// );

// export const TF = ({
//   label,
//   value,
//   onChange,
//   type = "text",
//   disabled,
//   multiline,
//   rows,
//   sx = {},
// }) => (
//   <TextField
//     label={label}
//     value={value ?? ""}
//     size="small"
//     fullWidth
//     type={type}
//     disabled={disabled}
//     multiline={multiline}
//     rows={rows}
//     InputLabelProps={type === "date" ? { shrink: true } : undefined}
//     onChange={onChange ? (e) => onChange(e.target.value) : undefined}
//     sx={sx}
//   />
// );

// export const SecHead = ({ label }) => (
//   <Box
//     sx={{
//       background: "#1976d2",
//       color: "#fff",
//       px: 2,
//       py: 1,
//       borderRadius: 1,
//       mb: 1,
//     }}
//   >
//     <Typography variant="body2" fontWeight="bold">
//       {label}
//     </Typography>
//   </Box>
// );

// const buildFYOptions = () => {
//   const opts = [];
//   const cur = new Date().getFullYear();
//   for (let y = 2015; y <= cur + 1; y++)
//     opts.push(`${y}-${String(y + 1).slice(2)}`);
//   return opts.reverse();
// };
// export const FY_OPTIONS = buildFYOptions();

// export const FYSelect = ({
//   value,
//   onChange,
//   disabled,
//   label = "Financial Year",
// }) => (
//   <FormControl size="small" fullWidth>
//     <InputLabel>{label}</InputLabel>
//     <Select
//       value={value || ""}
//       label={label}
//       disabled={disabled}
//       onChange={(e) => onChange && onChange(e.target.value)}
//     >
//       <MenuItem value="">
//         <em>— Select —</em>
//       </MenuItem>
//       {FY_OPTIONS.map((y) => (
//         <MenuItem key={y} value={y}>
//           {y}
//         </MenuItem>
//       ))}
//     </Select>
//   </FormControl>
// );

// export const SPLOCAHeader = ({
//   splocanNo,
//   date,
//   readOnly,
//   onNoChange,
//   onDateChange,
// }) => (
//   <Box sx={{ mb: 2 }}>
//     <Box sx={{ textAlign: "center", mb: 1 }}>
//       <Typography variant="h6" fontWeight="bold">
//         THE SPECIAL OFFICER AND COMPETENT AUTHORITY
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         3rd Floor, Podium Block, V.V. Tower, Dr. Ambedkar Veedhi, Bengaluru
//         -560001
//       </Typography>
//     </Box>
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "flex-start",
//         mb: 1,
//       }}
//     >
//       <Box>
//         <Typography variant="body2" fontWeight="bold">
//           No:
//         </Typography>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
//           <Typography variant="body2">SPLOCA /</Typography>
//           <TextField
//             size="small"
//             value={splocanNo || ""}
//             sx={{ width: 140 }}
//             disabled={readOnly}
//             onChange={
//               onNoChange ? (e) => onNoChange(e.target.value) : undefined
//             }
//           />
//           <Typography variant="body2">/ 2026</Typography>
//         </Box>
//       </Box>
//       <Box>
//         <Typography variant="body2" fontWeight="bold">
//           Date:
//         </Typography>
//         <TextField
//           type="date"
//           size="small"
//           value={date || TODAY}
//           InputLabelProps={{ shrink: true }}
//           sx={{ mt: 0.5, width: 180 }}
//           disabled={readOnly}
//           onChange={
//             onDateChange ? (e) => onDateChange(e.target.value) : undefined
//           }
//         />
//       </Box>
//     </Box>
//     <Divider />
//   </Box>
// );

// export const RowTable = ({
//   columns,
//   rows,
//   onAdd,
//   onUpdate,
//   onDel,
//   readOnly,
// }) => (
//   <Box>
//     <TableContainer component={Paper} variant="outlined" sx={{ mb: 1 }}>
//       <Table size="small">
//         <TableHead>
//           <TableRow sx={{ background: "#1976d2" }}>
//             <TableCell sx={{ color: "#fff", width: 50 }}>#</TableCell>
//             {columns.map((c) => (
//               <TableCell
//                 key={c.field}
//                 sx={{ color: "#fff", minWidth: c.width || 120 }}
//               >
//                 {c.label}
//               </TableCell>
//             ))}
//             {!readOnly && <TableCell sx={{ color: "#fff", width: 50 }} />}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {rows.length === 0 && (
//             <TableRow>
//               <TableCell colSpan={columns.length + 2} align="center">
//                 <Typography variant="caption" color="text.disabled">
//                   No rows — click Add Row
//                 </Typography>
//               </TableCell>
//             </TableRow>
//           )}
//           {rows.map((row, idx) => (
//             <TableRow
//               key={idx}
//               sx={{ background: idx % 2 === 0 ? "#fafafa" : "#fff" }}
//             >
//               <TableCell>{idx + 1}</TableCell>
//               {columns.map((c) => (
//                 <TableCell key={c.field}>
//                   {readOnly ? (
//                     <Typography variant="body2">{row[c.field]}</Typography>
//                   ) : c.type === "date" ? (
//                     <TextField
//                       type="date"
//                       size="small"
//                       value={row[c.field] || ""}
//                       InputLabelProps={{ shrink: true }}
//                       sx={{ minWidth: 150 }}
//                       onChange={(e) => onUpdate(idx, c.field, e.target.value)}
//                     />
//                   ) : (
//                     <TextField
//                       size="small"
//                       value={row[c.field] || ""}
//                       multiline={c.multiline}
//                       sx={{ minWidth: c.width || 120 }}
//                       onChange={(e) => onUpdate(idx, c.field, e.target.value)}
//                     />
//                   )}
//                 </TableCell>
//               ))}
//               {!readOnly && (
//                 <TableCell>
//                   <IconButton
//                     size="small"
//                     color="error"
//                     onClick={() => onDel(idx)}
//                   >
//                     <Delete fontSize="small" />
//                   </IconButton>
//                 </TableCell>
//               )}
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//     {!readOnly && (
//       <Button
//         size="small"
//         startIcon={<Add />}
//         variant="outlined"
//         onClick={onAdd}
//       >
//         Add Row
//       </Button>
//     )}
//   </Box>
// );

// export const ApprovalTimeline = ({ form, flowType }) => {
//   const steps =
//     flowType === "public"
//       ? [
//           {
//             label: "Shirastedar",
//             by: form.shirastedar_by,
//             at: form.shirastedar_at,
//             remarks: form.shirastedar_remarks,
//           },
//           {
//             label: "Tahsildar",
//             by: form.tahsildar_by,
//             at: form.tahsildar_at,
//             remarks: form.tahsildar_remarks,
//           },
//           {
//             label: "CA / Admin",
//             by: form.ca_by,
//             at: form.ca_at,
//             remarks: form.ca_remarks,
//           },
//         ]
//       : flowType === "petition"
//         ? [
//             {
//               label: "Legal",
//               by: form.legal_by,
//               at: form.legal_at,
//               remarks: form.legal_remarks,
//             },
//             {
//               label: "AC",
//               by: form.ac_by,
//               at: form.ac_at,
//               remarks: form.ac_remarks,
//             },
//             {
//               label: "Joint Secretary",
//               by: form.js_by,
//               at: form.js_at,
//               remarks: form.js_remarks,
//             },
//             {
//               label: "CA / SPLOCA",
//               by: form.ca_approver_by,
//               at: form.ca_approver_at,
//               remarks: form.ca_approver_remarks,
//             },
//           ]
//         : [
//             {
//               label: "Shirastedar",
//               by: form.shirastedar_by,
//               at: form.shirastedar_at,
//               remarks: form.shirastedar_remarks,
//             },
//             {
//               label: "Legal",
//               by: form.legal_by,
//               at: form.legal_at,
//               remarks: form.legal_remarks,
//             },
//             {
//               label: "AC",
//               by: form.ac_by,
//               at: form.ac_at,
//               remarks: form.ac_remarks,
//             },
//             {
//               label: "Joint Secretary",
//               by: form.js_by,
//               at: form.js_at,
//               remarks: form.js_remarks,
//             },
//             {
//               label: "CA / SPLOCA",
//               by: form.ca_by,
//               at: form.ca_at,
//               remarks: form.ca_remarks,
//             },
//           ];
//   return (
//     <Box
//       sx={{
//         mt: 2,
//         p: 2,
//         border: "1px solid #e0e0e0",
//         borderRadius: 2,
//         background: "#fafafa",
//       }}
//     >
//       <Typography variant="subtitle2" fontWeight="bold" mb={1}>
//         <History fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
//         Approval History
//       </Typography>
//       {steps.map((s, i) => (
//         <Box
//           key={i}
//           sx={{
//             display: "flex",
//             gap: 2,
//             mb: 0.5,
//             pl: 1,
//             borderLeft: `3px solid ${s.at ? "#1976d2" : "#ddd"}`,
//           }}
//         >
//           <Box>
//             <Typography variant="caption" fontWeight="bold">
//               {s.label}
//             </Typography>
//             {s.at ? (
//               <>
//                 <Typography
//                   variant="caption"
//                   display="block"
//                   color="text.secondary"
//                 >
//                   {new Date(s.at).toLocaleString("en-IN")}
//                 </Typography>
//                 {s.remarks && (
//                   <Typography
//                     variant="caption"
//                     color="text.secondary"
//                     sx={{ fontStyle: "italic" }}
//                   >
//                     "{s.remarks}"
//                   </Typography>
//                 )}
//               </>
//             ) : (
//               <Typography
//                 variant="caption"
//                 display="block"
//                 color="text.disabled"
//               >
//                 Pending
//               </Typography>
//             )}
//           </Box>
//         </Box>
//       ))}
//     </Box>
//   );
// };



import React from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { Add, Delete, History } from "@mui/icons-material";

export const TODAY = new Date().toISOString().split("T")[0];

export const STATUS_META = {
  draft: { label: "Draft", color: "default" },
  submitted: { label: "Submitted", color: "primary" },
  legal_review: { label: "Legal Review", color: "info" },
  approved_l1: { label: "Approved (Shirastedar)", color: "success" },
  rejected_l1: { label: "Rejected (Shirastedar)", color: "error" },
  approved_l2: { label: "Approved (Tahsildar)", color: "success" },
  rejected_l2: { label: "Rejected (Tahsildar)", color: "error" },
  approved_l3: { label: "Approved (CA)", color: "success" },
  rejected_l3: { label: "Rejected (CA)", color: "error" },
  approved_ac: { label: "Approved (AC)", color: "success" },
  rejected_ac: { label: "Rejected (AC)", color: "error" },
  approved_js: { label: "Approved (JS)", color: "success" },
  rejected_js: { label: "Rejected (JS)", color: "error" },
  approved_ca: { label: "Approved (CA/SPLOCA)", color: "success" },
  rejected_ca: { label: "Rejected (CA/SPLOCA)", color: "error" },
  issued: { label: "Issued", color: "success" },
  final: { label: "Finalised", color: "success" },
};

export const StatusChip = ({ status }) => {
  const m = STATUS_META[status] || { label: status, color: "default" };
  return <Chip label={m.label} color={m.color} size="small" />;
};

export const FG = ({ children, cols = 3, sx = {} }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: `repeat(${cols}, 1fr)`,
      gap: 2,
      mb: 2,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export const TF = ({
  label,
  value,
  onChange,
  type = "text",
  disabled,
  multiline,
  rows,
  sx = {},
}) => (
  <TextField
    label={label}
    value={value ?? ""}
    size="small"
    fullWidth
    type={type}
    disabled={disabled}
    multiline={multiline}
    rows={rows}
    InputLabelProps={type === "date" ? { shrink: true } : undefined}
    onChange={onChange ? (e) => onChange(e.target.value) : undefined}
    sx={sx}
  />
);

export const SecHead = ({ label }) => (
  <Box
    sx={{
      background: "#1976d2",
      color: "#fff",
      px: 2,
      py: 1,
      borderRadius: 1,
      mb: 1,
    }}
  >
    <Typography variant="body2" fontWeight="bold">
      {label}
    </Typography>
  </Box>
);

const buildFYOptions = () => {
  const opts = [];
  const cur = new Date().getFullYear();
  for (let y = 2015; y <= cur + 1; y++)
    opts.push(`${y}-${String(y + 1).slice(2)}`);
  return opts.reverse();
};
export const FY_OPTIONS = buildFYOptions();

export const FYSelect = ({
  value,
  onChange,
  disabled,
  label = "Financial Year",
}) => (
  <FormControl size="small" fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      value={value || ""}
      label={label}
      disabled={disabled}
      onChange={(e) => onChange && onChange(e.target.value)}
    >
      <MenuItem value="">
        <em>— Select —</em>
      </MenuItem>
      {FY_OPTIONS.map((y) => (
        <MenuItem key={y} value={y}>
          {y}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export const SPLOCAHeader = ({
  splocanNo,
  date,
  readOnly,
  onNoChange,
  onDateChange,
}) => (
  <Box sx={{ mb: 2 }}>
    <Box sx={{ textAlign: "center", mb: 1 }}>
      <Typography variant="h6" fontWeight="bold">
        THE SPECIAL OFFICER AND COMPETENT AUTHORITY
      </Typography>
      <Typography variant="body2" color="text.secondary">
        3rd Floor, Podium Block, V.V. Tower, Dr. Ambedkar Veedhi, Bengaluru
        -560001
      </Typography>
    </Box>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        mb: 1,
      }}
    >
      <Box>
        <Typography variant="body2" fontWeight="bold">
          No:
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
          <Typography variant="body2">SPLOCA /</Typography>
          <TextField
            size="small"
            value={splocanNo || ""}
            sx={{ width: 140 }}
            disabled={readOnly}
            onChange={
              onNoChange ? (e) => onNoChange(e.target.value) : undefined
            }
          />
          <Typography variant="body2">/ 2026</Typography>
        </Box>
      </Box>
      <Box>
        <Typography variant="body2" fontWeight="bold">
          Date:
        </Typography>
        <TextField
          type="date"
          size="small"
          value={date || TODAY}
          InputLabelProps={{ shrink: true }}
          sx={{ mt: 0.5, width: 180 }}
          disabled={readOnly}
          onChange={
            onDateChange ? (e) => onDateChange(e.target.value) : undefined
          }
        />
      </Box>
    </Box>
    <Divider />
  </Box>
);

export const RowTable = ({
  columns,
  rows,
  onAdd,
  onUpdate,
  onDel,
  readOnly,
}) => (
  <Box>
    <TableContainer component={Paper} variant="outlined" sx={{ mb: 1 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ background: "#1976d2" }}>
            <TableCell sx={{ color: "#fff", width: 50 }}>#</TableCell>
            {columns.map((c) => (
              <TableCell
                key={c.field}
                sx={{ color: "#fff", minWidth: c.width || 120 }}
              >
                {c.label}
              </TableCell>
            ))}
            {!readOnly && <TableCell sx={{ color: "#fff", width: 50 }} />}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={columns.length + 2} align="center">
                <Typography variant="caption" color="text.disabled">
                  No rows — click Add Row
                </Typography>
              </TableCell>
            </TableRow>
          )}
          {rows.map((row, idx) => (
            <TableRow
              key={idx}
              sx={{ background: idx % 2 === 0 ? "#fafafa" : "#fff" }}
            >
              <TableCell>{idx + 1}</TableCell>
              {columns.map((c) => (
                <TableCell key={c.field}>
                  {readOnly ? (
                    <Typography variant="body2">{row[c.field]}</Typography>
                  ) : c.type === "date" ? (
                    <TextField
                      type="date"
                      size="small"
                      value={row[c.field] || ""}
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 150 }}
                      onChange={(e) => onUpdate(idx, c.field, e.target.value)}
                    />
                  ) : (
                    <TextField
                      size="small"
                      value={row[c.field] || ""}
                      multiline={c.multiline}
                      sx={{ minWidth: c.width || 120 }}
                      onChange={(e) => onUpdate(idx, c.field, e.target.value)}
                    />
                  )}
                </TableCell>
              ))}
              {!readOnly && (
                <TableCell>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => onDel(idx)}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    {!readOnly && (
      <Button
        size="small"
        startIcon={<Add />}
        variant="outlined"
        onClick={onAdd}
      >
        Add Row
      </Button>
    )}
  </Box>
);

// ─────────────────────────────────────────────────────────────────────────────
// APPROVAL TIMELINE
//
// For legal and petition flows the post-legal approval is flat:
// exactly ONE of AC / JS / CA-SPLOCA will have acted; the others are skipped.
//
// Step rendering rules:
//   • acted (at is set)  → blue left-bar, show timestamp + remarks
//   • issued/final       → green left-bar, "Finalized" terminal step
//   • skipped (form is issued/final/rejected but this step was never touched)
//                        → grey left-bar, "N/A"
//   • pending (form not yet reached this stage)
//                        → grey left-bar dashed, "Pending"
// ─────────────────────────────────────────────────────────────────────────────

// Terminal statuses where nothing further is expected
const TERMINAL = new Set(["issued", "final"]);

// Statuses that mean the form has moved past draft/submitted into real workflow
const ACTIVE_STATUSES = new Set([
  "submitted", "legal_review",
  "approved_l1", "rejected_l1",
  "approved_l2", "rejected_l2",
  "approved_l3", "rejected_l3",
  "approved_ac", "rejected_ac",
  "approved_js", "rejected_js",
  "approved_ca", "rejected_ca",
  "issued", "final",
]);

// For the flat post-legal approval: a step is "skipped" when the form is
// terminal (issued/final) but this particular role never acted (no `at` value).
const StepRow = ({ label, at, remarks, isTerminal, formStatus }) => {
  const acted = !!at;

  // A step is skipped when the overall form is done but this role wasn't involved
  const skipped = !acted && TERMINAL.has(formStatus);

  // Pending = not acted, not skipped (form still in progress)
  const pending = !acted && !skipped;

  let borderColor = "#ddd";
  let borderStyle = "solid";
  let statusText = null;
  let statusColor = "text.disabled";

  if (acted) {
    borderColor = "#1976d2";
  } else if (skipped) {
    borderColor = "#bdbdbd";
    statusText = "N/A";
    statusColor = "text.disabled";
  } else {
    borderColor = "#ddd";
    borderStyle = "dashed";
    statusText = "Pending";
    statusColor = "text.disabled";
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mb: 0.5,
        pl: 1,
        borderLeft: `3px ${borderStyle} ${borderColor}`,
      }}
    >
      <Box>
        <Typography variant="caption" fontWeight="bold" color={acted ? "text.primary" : "text.secondary"}>
          {label}
        </Typography>
        {acted ? (
          <>
            <Typography variant="caption" display="block" color="text.secondary">
              {new Date(at).toLocaleString("en-IN")}
            </Typography>
            {remarks && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontStyle: "italic" }}
              >
                "{remarks}"
              </Typography>
            )}
          </>
        ) : (
          <Typography variant="caption" display="block" color={statusColor}>
            {statusText}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

// Terminal "Issued / Finalised" row shown at the bottom when done
const FinalRow = ({ formStatus }) => {
  if (!TERMINAL.has(formStatus)) return null;
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mt: 1,
        pl: 1,
        borderLeft: "3px solid #2e7d32",
      }}
    >
      <Box>
        <Typography variant="caption" fontWeight="bold" color="success.dark">
          {formStatus === "final" ? "Finalised" : "Issued"}
        </Typography>
        <Typography variant="caption" display="block" color="success.main">
          Completed
        </Typography>
      </Box>
    </Box>
  );
};

export const ApprovalTimeline = ({ form, flowType }) => {
  const status = form.status || "";

  // ── PUBLIC RECORD flow (sequential, unchanged) ───────────────────────────
  if (flowType === "public") {
    const steps = [
      {
        label: "Shirastedar",
        at: form.shirastedar_at,
        remarks: form.shirastedar_remarks,
      },
      {
        label: "Tahsildar",
        at: form.tahsildar_at,
        remarks: form.tahsildar_remarks,
      },
      {
        label: "CA / Admin",
        at: form.ca_at,
        remarks: form.ca_remarks,
      },
    ];

    return (
      <Box
        sx={{
          mt: 2,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          background: "#fafafa",
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" mb={1}>
          <History fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
          Approval History
        </Typography>
        {steps.map((s, i) => (
          <StepRow key={i} {...s} formStatus={status} />
        ))}
        <FinalRow formStatus={status} />
      </Box>
    );
  }

  // ── LEGAL (Summons / Warrant) flow ───────────────────────────────────────
  // Shirastedar + Legal are sequential; then ONE of AC / JS / CA acts.
  if (flowType === "legal") {
    // The three optional parallel approvers — only one will have acted
    const parallelSteps = [
      {
        label: "AC",
        at: form.ac_at,
        remarks: form.ac_remarks,
      },
      {
        label: "Joint Secretary",
        at: form.js_at,
        remarks: form.js_remarks,
      },
      {
        label: "CA / SPLOCA",
        at: form.ca_at,
        remarks: form.ca_remarks,
      },
    ];

    // Determine which parallel step acted (if any)
    const anyParallelActed = parallelSteps.some((s) => !!s.at);

    return (
      <Box
        sx={{
          mt: 2,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          background: "#fafafa",
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" mb={1}>
          <History fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
          Approval History
        </Typography>

        {/* Sequential steps */}
        <StepRow
          label="Shirastedar"
          at={form.shirastedar_at}
          remarks={form.shirastedar_remarks}
          formStatus={status}
        />
        <StepRow
          label="Legal"
          at={form.legal_at}
          remarks={form.legal_remarks}
          formStatus={status}
        />

        {/* Parallel approver section label */}
        <Typography
          variant="caption"
          color="text.disabled"
          sx={{ pl: 1, display: "block", mt: 1, mb: 0.5, fontStyle: "italic" }}
        >
          Senior approval (one of the following)
        </Typography>

        {parallelSteps.map((s, i) => {
          // If another parallel step acted and this one didn't → N/A
          const otherActed = anyParallelActed && !s.at;
          const effectiveStatus = otherActed ? "issued" : status;
          return (
            <StepRow key={i} {...s} formStatus={effectiveStatus} />
          );
        })}

        <FinalRow formStatus={status} />
      </Box>
    );
  }

  // ── PETITION flow ─────────────────────────────────────────────────────────
  // Legal submits directly; then ONE of AC / JS / CA acts.
  if (flowType === "petition") {
    const parallelSteps = [
      {
        label: "AC",
        at: form.ac_at,
        remarks: form.ac_remarks,
      },
      {
        label: "Joint Secretary",
        at: form.js_at,
        remarks: form.js_remarks,
      },
      {
        label: "CA / SPLOCA",
        at: form.ca_approver_at,
        remarks: form.ca_approver_remarks,
      },
    ];

    const anyParallelActed = parallelSteps.some((s) => !!s.at);

    return (
      <Box
        sx={{
          mt: 2,
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          background: "#fafafa",
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" mb={1}>
          <History fontSize="small" sx={{ mr: 0.5, verticalAlign: "middle" }} />
          Approval History
        </Typography>

        <StepRow
          label="Legal"
          at={form.legal_at}
          remarks={form.legal_remarks}
          formStatus={status}
        />

        <Typography
          variant="caption"
          color="text.disabled"
          sx={{ pl: 1, display: "block", mt: 1, mb: 0.5, fontStyle: "italic" }}
        >
          Senior approval (one of the following)
        </Typography>

        {parallelSteps.map((s, i) => {
          const otherActed = anyParallelActed && !s.at;
          const effectiveStatus = otherActed ? "issued" : status;
          return (
            <StepRow key={i} {...s} formStatus={effectiveStatus} />
          );
        })}

        <FinalRow formStatus={status} />
      </Box>
    );
  }

  return null;
};